import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PlayPauseButtons from '../common/PlayPauseButtons.js';
import * as imageUtils from '../../utils/imageUtils';
import urls from '../../constants/urls.js';
import ArtistService from '../../services/artistService.js';
import trimStart from 'lodash/trimStart';

const FeaturedArtist = ({artist}) => { 

    const ShouldDisplayGenre = (genre) => {
        return (genre.length <= 27 && (genre.toLowerCase() != "other" || artist.genres.length <= 2));        
    };

    const getThumbnail = (imageUrl, roleType) => {        
        const params = '?width=240&aspectw=1.5&quality=80&mode=crop&scale=both&format=jpg';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    };

    return (
        <li className="transition2">
            <Link to={`/${artist.Username}`} className="coverlink">
                <div className="covers-desc">
                    <div className="imgbox">
                        <img className="coverimage" src={getThumbnail(artist.ImagePath, artist.RoleType)} alt={artist.Name} />
                    </div>
                    <span className="shade transition2" />
                    <span className="shadeorange transition2" />
                    <div className="covers-songinfo">
                        <p className="transition2">{artist.TrackName}</p>
                        <div className="tagslist transition2">
                        
                        {artist.Genres.slice(0, 5).map((genre) =>                        
                            ShouldDisplayGenre(genre) ? <span key={genre} className="badge transition2">{genre}</span> : null  
                        )}
                        </div>
                    </div>
                </div>
                <div className="covers-title">
                    <h2 className="transition2">{artist.Name}</h2>
                </div>
            </Link>
            <PlayPauseButtons trackID={artist.TrackID} anchorClass="btn-play play transition2" spanClass="circ transition" playButtonClass="icon icn-play transition" pauseButtonClass="icon icn-pause transition" />  
        </li>
    );
};

FeaturedArtist.propTypes = {
    artist: PropTypes.object.isRequired
};

export default FeaturedArtist;

